module.exports = __webpack_public_path__ + "media/images/flags/bo-0435cb1af0df2bfd8eba06410d99cdb7.svg";